import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Field, Form as FinalForm } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldDateInput,
  FieldTextInput,
  FieldPhoneNumberInput,
} from '../../components';

import css from './VtigerBookingEditForm.module.css';

/**
 * This component is hacked together by mirroring the change password component but
 * minus proper internationalisation, as the expectation is it will be replaced in the
 * coming weeks with a move to a new CRM.
 */
class VtigerBookingEditFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.submittedValues = {};
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    this.props.onSubmit(this.submittedValues);
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        render={fieldRenderProps => {
          const {
            booking,
            rootClassName,
            className,
            formId,
            handleSubmit,
            inProgress,
            intl,
            invalid,
            pristine,
            ready,
            someError,
            form,
            values,
          } = fieldRenderProps;

          // No `ensureCurrentUser()` because we rely on server API checks for CRM-only data amends.

          // todo counterparts of this for all fields
          // const newPasswordRequired = validators.requiredStringNoTrim(newPasswordRequiredMessage);

          const genericFailure = someError ? (
            <span className={css.error}>Please ensure all fields are filled in correctly.</span>
          ) : null;

          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);
          const classes = classNames(rootClassName || css.root, className);
          const submitDisabled = invalid || pristineSinceLastSubmit || inProgress;

          const startTimeRequired = validators.requiredStringNoTrim('Start time is required');
          const endTimeRequired = validators.requiredStringNoTrim('End time is required');

          return (
            <Form
              className={classes}
              onSubmit={e => {
                this.submittedValues = values;
                handleSubmit(e).catch(() => {
                  // Error is handled in duck file already.
                });
              }}
            >
              <div>
                <h3 className={css.editFormMessage}>
                  You can edit the following details in the form below
                </h3>
                <FieldDateInput
                  className={css.field}
                  id="date"
                  name="date"
                  label="Date"
                  placeholderText="Date"
                  defaultValue={booking.date}
                />

                <FieldTextInput
                  type="text"
                  className={css.field}
                  id="hour"
                  name="hour"
                  label="Start time"
                  defaultValue={booking.hour}
                  validate={startTimeRequired}
                />

                <FieldTextInput
                  type="text"
                  className={css.field}
                  id="hour9"
                  name="hour9"
                  label="End time"
                  defaultValue={booking.hour9}
                  validate={endTimeRequired}
                />

                <FieldTextInput
                  type="textarea"
                  className={css.field}
                  id="session_notes"
                  name="session_notes"
                  label="Session notes"
                  defaultValue={booking.session_notes}
                />

                <FieldTextInput
                  type="text"
                  className={css.field}
                  id="deaf_person_name"
                  name="deaf_person_name"
                  label="Deaf Person's Name"
                  defaultValue={booking.deaf_person_name}
                />

                <FieldPhoneNumberInput
                  type="text"
                  className={css.field}
                  id="deaf_person_phone_number"
                  name="deaf_person_phone_number"
                  label="Deaf Person's Phone Number"
                  defaultValue={booking.deaf_person_phone_number}
                />

                <Field
                  component="input"
                  type="hidden"
                  name="notes_start"
                  defaultValue={booking.notes_start}
                />

                <Field
                  component="input"
                  type="hidden"
                  name="notes_end"
                  defaultValue={booking.notes_end}
                />
              </div>

              <div className={css.bottomWrapper}>
                {genericFailure}
                <PrimaryButton
                  type="submit"
                  className={css.saveBookingButton}
                  inProgress={inProgress}
                  ready={ready}
                  disabled={submitDisabled}
                >
                  Save edit
                </PrimaryButton>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

VtigerBookingEditFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  someError: null,
  inProgress: false,
  formId: null,
};

const { bool, string } = PropTypes;

VtigerBookingEditFormComponent.propTypes = {
  booking: propTypes.vtigerBookingForEdit.isRequired,
  rootClassName: string,
  className: string,
  inProgress: bool,
  intl: intlShape.isRequired,
  formId: string,
};

const VtigerBookingEditForm = compose(injectIntl)(VtigerBookingEditFormComponent);
VtigerBookingEditForm.displayName = 'VtigerBookingEditForm';

export default VtigerBookingEditForm;
